import { z } from "zod";

export const keyValue = z.object({
  key: z.string(),
  value: z.string(),
});

export type KeyValue = z.infer<typeof keyValue>;
